import { useForm, usePage } from '@inertiajs/react'
import Layout from '@/components/layout/Layout'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { PageProps } from '@/types'

interface Invitation {
  id: string
  email: string
  expires_at: string
  token: string
}

interface Props extends PageProps {
  invitations: Invitation[]
}

export default function Invitations() {
  const { invitations } = usePage<Props>().props
  const { data, setData, post, processing, reset } = useForm({ email: '' })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post('/invitations', { onSuccess: () => reset() })
  }

  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-2xl font-bold">Invitations</h1>

        <Card className="border-gray-200 bg-white">
          <CardHeader>
            <CardTitle className="text-gray-900">Invite a User</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="flex gap-3">
              <div className="flex-1">
                <Label htmlFor="email" className="sr-only">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="user@example.com"
                  value={data.email}
                  onChange={e => setData('email', e.target.value)}
                />
              </div>
              <Button type="submit" disabled={processing}>Send Invite</Button>
            </form>
          </CardContent>
        </Card>

        {invitations.length > 0 && (
          <Card className="border-gray-200 bg-white">
            <CardHeader>
              <CardTitle className="text-gray-900">Pending Invitations</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                {invitations.map(invite => (
                  <div key={invite.id} className="flex items-center justify-between rounded-md bg-gray-100 px-3 py-2 text-sm">
                    <span className="text-gray-700">{invite.email}</span>
                    <span className="text-gray-400">
                      Expires {new Date(invite.expires_at).toLocaleDateString()}
                    </span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </Layout>
  )
}
